<template>
  <v-card class="overflow-hidden v-card v-sheet theme-light m-0">
    <!-- alert messsage -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{alert_message}}</v-alert>
    </div>
    <headerComponent :headerTitle="headerText"></headerComponent>

    <!-- Header -->
    <v-card class="v-card-100 mt-3">
      <v-tabs v-model="tab_index">
        <v-tab class="component-tab-heading" ripple :href="'#'" @click="loadData(tab, 'tab_clicked')"
          style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in tabs"
          :key="index">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>
      <!-- search, filter, Action buttons -->
      <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style pb-1">
      <v-row>
        <v-row>
          <v-col cols="8" sm="8" class="ma-3">
            <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" style="max-width: 300px;" variant="outlined" v-on:keyup.enter="loadData(active_tab)" ></v-text-field>
          </v-col>
        </v-row>

        <!-- Actions buttons -->
        <v-card-actions class="pb-10">
          <v-menu offset-y v-if="active_tab == 'To Be Cannibalized'  && isActionAllowed(role)">
            <template v-slot:activator="{ props }">
              <v-btn :color="selected.length==0? '' : 'primary'" variant="flat" size="x-large" v-bind="props" class="mr-2 text-none" :disabled="selected.length==0">
                Change Disposition
                <v-icon :color="selected.length==0? 'grey' : 'white'" dark>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in change_disposition_list" :key="index" @click="changeDisposition(item)">
                <v-list-item-title>{{ item.original_code }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu offset-y v-if="active_tab == 'Cannibalized'  && isActionAllowed(role)">
            <template v-slot:activator="{ props }">
              <v-btn :color="selected.length==0 ? '' : 'primary'" variant="flat" size="x-large" v-bind="props" class="mr-2 text-none" :disabled="selected.length==0">
                Change Disposition
                <v-icon :color="selected.length==0? 'grey' : 'white'" dark>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in change_disposition" :key="index" @click="askToBeCannibalized(item)">
                <v-list-item-title>{{ item.original_code }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-actions>
            
        <!-- Filter -->
        <v-expansion-panels class="custom-control_outlined ma-2" ref = "filterPopupRef" readonly style="max-width: 300px; margin-bottom: 16px; min-height: 52px;">
          <v-expansion-panel variant="outlined" @click="filterListOfButtons" style="height: 52px;">
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-row>
      </v-card-title>

      <!-- Table Data -->
      <v-layout column>
        <v-col cols="12" style="overflow : auto" class="p-0">
          <v-data-table hover 
            density="compact"
            :search="search"
            v-model="selected"
            show-select
            disable-pagination 
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            :loading="loading"
            fixed-header 
            height="100%"
            :items-per-page="pageSize"
            loading-text="Loading Data... Please wait" class="elevation-1"
            return-object
            >
            <template v-slot:[`item.${headers.key}`]="{ item }" v-for="headers in headers">
             <span v-if="headers.key == 'uom' && active_tab == 'Cannibalized'">
                {{ item.article_type != "Finished Goods" ? item.uom  : '-' }}
              </span>
              <span v-else-if="headers.key == 'condition' && active_tab == 'Cannibalized'">
                {{ item.article_type != "Finished Goods" ? item.condition : '-' }}
              </span>
               <span v-else-if="headers.key == 'tag_id' && active_tab == 'Cannibalized' && item.completely_not_cannibalized">
                <a href="#" @click.prevent="itemDetailPopup(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.tag_id }}</a>
              </span>    
              <span v-else-if="item[headers.key]">
                <GlobalTooltip :text="item[headers.key]" />
              </span>
              <span v-else>-</span>
            </template>
            <!-- <template #[`item.article_type`] = "{ item }">
              <span>{{ item.article_type ? item.article_type : '-' }}</span>
            </template> -->
            <template #bottom></template>
          </v-data-table>
        </v-col>
      </v-layout>
      <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
            </div>

      <!-- Pagination and Number of selected item -->
      <!-- <v-container fluid>
        <v-row class="ml-2 pb-0">
          <v-col cols="3" sm="3" class="PaddingItemPerPage d-flex mt-3">
            <label class="" style="margin-top: -2px;">Rows Per Page</label>
            <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
            variant="outlined" style="width: 40px;margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
          </v-col>
          <span class="item-selected"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
              v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
          <v-spacer></v-spacer>
          <span class="pt-3 mt-3 mr-5" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
            - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
          <v-col cols="2" sm="2" class="PaddingItemPerPage custom-column-ui">
            <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
              @update:modelValue="handlePageChange" circle></v-pagination>
          </v-col>
        </v-row>
      </v-container> -->

      <!-- filter data popup -->
      <v-row justify="center">
        <v-dialog content-class="filter-data" v-model="filterPopup" persistent max-width="1232px">
          <v-card style="max-width: 100% !important;">
            <v-row class='m-0'>
              <v-col>
              <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="tag_id_search"  label="Tag Id" class="ma-2" variant="outlined"></v-text-field>
              </v-col>
              <v-col>
              <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="article_id_search"  label="Article Id" class="ma-2" variant="outlined"></v-text-field>
              </v-col>
              <v-col>
              <v-combobox color="primary" v-model="selected_cond" :items="condition_list" item-title="name" item-value="id" label="Condition"  variant="outlined" class="ma-2" > </v-combobox>
              </v-col>
              <v-col v-if="active_tab == 'Work In Progress' || active_tab == 'Cannibalized'">
              <v-combobox color="primary" v-model="selected_uom" :items="uom_list" item-title="name" item-value="id" label="UOM"  variant="outlined" class="ma-2" > </v-combobox>
              </v-col>
              <v-col v-if="active_tab == 'Work In Progress' || active_tab == 'Cannibalized'">
              <v-combobox color="primary" v-model="selected_article_type" :items="articleType_list" item-title="name" item-value="id" label="Article Type"  variant="outlined" class="ma-2" > </v-combobox>
              </v-col>
              <v-col v-if="active_tab == 'To Be Cannibalized'">
              <v-combobox color="primary" v-model="selected_article" :items="articleType_list1" item-title="name" item-value="id" label="Article Type"  variant="outlined" class="ma-2" > </v-combobox>
              </v-col>
            </v-row>
            <v-card-actions class="margin-10">
              <v-spacer></v-spacer>
              <v-btn size="small" variant="text outlined" color="primary" class="btn-cancel" @click="filterPopup = false">CANCEL</v-btn>
              <v-btn size="small" variant="flat" color="primary" @click="ApplyFilterFunc">APPLY FILTER(S)</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <!-- Change Disposition, To Be Cannibalized  confirm and success Popup -->
      <v-row justify="center">
        <v-dialog v-model="toBeDisposition" persistent max-width="424px">
          <v-card class="v-card-100 pa-2">
            <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span></span>
                  <v-spacer></v-spacer>
                    <v-icon @click="toBeDisposition = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
            <v-card-text class="text-center">
              <span> Are you sure want to move this item to {{ dispos_action.original_code }} ? </span>
            </v-card-text>
            <v-card-actions center class="mt-2">
              <v-spacer></v-spacer>
              <v-btn size="small" variant="outlined" color="primary" class="cancel-color mb-1 text-none" @click="toBeDisposition = false">Cancel</v-btn>   
              <v-btn size="small" color="white" class="mb-1 bg-blue text-none" @click="changeDispos()">Confirm</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="canniDisposition" persistent max-width="424px">
          <v-card class="v-card-100 pa-2">
            <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span></span>
                  <v-spacer></v-spacer>
                    <v-icon @click="canniDisposition = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
            <v-card-text class="text-center">
              <span> Are you sure want to move this item to {{ dispos_action.original_code }} ? </span>
            </v-card-text>
            <v-card-actions center class="mt-2">
              <v-spacer></v-spacer>
              <v-btn size="small" variant="outlined" color="primary" class="cancel-color mb-1 text-none " @click="canniDisposition = false">Cancel</v-btn>
              <v-btn size="small" color="white" class="mb-1 bg-blue text-none" @click="callToBeCannibalized">Confirm</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="openPopUp" persistent max-width="424px">
          <v-card class="v-card-100 pa-2">
            <v-card-title class="d-flex align-center">
              <v-spacer></v-spacer>
              <v-btn variant="solo" icon @click="openPopUp = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider :thickness="4" class="m-0" />
            <v-card-text class="text-center">
              <span>{{ message }}</span>
            </v-card-text>
            <v-card-actions center class="mt-2">
              <v-spacer></v-spacer>
              <v-btn size="small" variant="outlined" color="primary" class="cancel-color mb-3" @click="openPopUp = false">Cancel</v-btn>
              <v-btn size="small" color="white" class="mb-3 bg-blue" @click ="loadData(active_tab)">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <!-- inf data -->
      <v-row justify="center">
        <v-dialog v-model="detailsPopup" persistent max-width="800px">
          <v-card class="v-card-100 pa-2">
            <v-card class="v-card-100 custom-shadow ma-0">
            <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span class="font-weight-bold">Details</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="detailsPopup = false">mdi-close</v-icon>
                </v-row>              
            </v-card-title>
            </v-card>
            <v-card-text class="text-center">
            <v-layout column class="custom-width-table">
              <v-data-table hover
                  density="compact"
                  :search="search"
                  v-model="selected_details"
                  :headers="details_headers"
                  :items="details_table_data"
                  disable-pagination 
                 :hide-default-footer="true"
                  :loading="loading"
                  loading-text="Loading Data... Please wait"
                  class="elevation-1"
                  return-object
                >
                <template v-slot:[`item.${headers.key}`]="{ item }" v-for="headers in headers">   
                <span v-if="item[headers.key]">
                  <GlobalTooltip :text="item[headers.key]" />
                </span>
                <span v-else>-</span>
              </template>
                </v-data-table>
            </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
  </v-card>
</template>
<script>
  import HeaderComponent from './../../../../commoncomponents/HeaderComponent';
  import { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction } from '@/backend/axios/moduleAccess'
  import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';

  export default {
    components : {
      HeaderComponent,
    },
    data() {
      return {
        headerText : "Cannibalization",
        tab_index: 0,
        alert_type : 'success',
        alert : false,
        alert_message : '',
        tabs : ["To Be Cannibalized", "Work In Progress", "Cannibalized"],
        active_tab : '',
        openPopUp : false,
        popUpType : '',
        dispos_action : '',
        filterPopup : false,
        search_tag: '',
        change_disposition_list : [],
        selected_article_type : null,
        selected_article: null,
        selected_cond : null,
        tag_id_search : '',
        article_id_search : '',
        articleType_list1 :[
          {
            "name":"Finished Goods",
            "id": "Finished Goods"
          },
          {
            "name":"Semi Finished Goods",
            "id": "Semi Finished Goods"
          }
        ],
        condition_list : [
          {
            "name":"Damaged",
            "id": "Damaged"
          },
          {
            "name":"Good",
            "id": "Good"
          }
        ],
        articleType_list : [
          {
            "name":"Finished Goods",
            "id": "Finished Goods"
          },
          {
            "name":"Semi Finished Goods",
            "id": "Semi Finished Goods"
          },
          {
            "name":"Parts And Spares",
            "id": "Parts And Spares"
          },
          {
            "name":"Packaging Material",
            "id": "Packaging Material"
          }
        ],
        selected : [],
        loading : false,
        headers : [],
        table_data : [],
        search  : '',
        page: 1,
        totalPages: 1,
        totalCount: '',
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        message : '',
        selected_uom:null,
        uom_list:[
          {
            "name":"Number",
            "id": "Number"
          },
          {
            "name":"Liter",
            "id": "Liter"
          },
          {
            "name":"Kilogram",
            "id": "Kilogram"
          }
        ],
        change_disposition:[],
        canniDisposition : false,
        toBeDisposition: false,
        isFilteringPage: false,
        filterPageNo : 1,
        role: '',
        details_headers : [],
        details_table_data : [],
        detailsPopup : false,
        selected_details : [],
      }
    },
    async created(){
      this.scrollToTop();
      this.role = this.$store.state.currentUser.roles[0]
      if(this.role in module_that_allowed && moduleAccessFunc(this.role,'Cannibalization')){
        signout()
        return;
      }
      this.loadData('To Be Cannibalized');
    },
    methods : {
      isActionAllowed(){
        return !isOnlyViewAction(this.role, 'Cannibalization')
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      showAlert(alert_type, alert_message) {
        this.scrollToTop();
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      },
      loadData(tab,tab_action){
        if(tab_action == 'tab_clicked'){
          this.search_tag = '';
        }
        this.loading = true;
        this.openPopUp = false;
        this.selected = []
        this.active_tab = tab
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.pageSize = 100
        this.filterPageNo = 1
        this.isFilteringPage = false
        if(tab == 'To Be Cannibalized'){
          this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key:"tag_id"},
            { title: "Article ID", key: "article_id" },
            { title: "Article Description", key: "item_description" },
            { title: "Quantity", key: "quantity"},
            // { title: "UOM", key: "uom"},
            // { title: "Condition", key: "condition"},
            { title: "Ageing (Days)", key: "ageing"},
            { title: "Article Type", key: "article_type"},
          ],
          this.fetchToBeCannibalized();
          this.getDisposition();
        } else if(tab == 'Work In Progress'){
          this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key:"tag_id"},
            { title: "Article ID", key: "article_id" },
            { title: "Article Description", key: "item_description" },
            { title: "Ageing", key: "ageing"},
            { title: "Quantity", key: "quantity"},
            { title: "UOM", key: "uom"},
            { title: "Condition", key: "condition"},
            { title: "Article Type", key: "article_type"},
          ],
          this.fetchWIP();
        } else {
          this.headers = [
            { title: "Tag ID", align: "start", sortable: false, key:"tag_id"},
            { title: "Article ID", key: "article_id" },
            { title: "Article Description", key: "item_description" },
            { title: "Ageing", key: "ageing"},
            { title: "Quantity", key: "quantity"},
            { title: "UOM", key: "uom"},
            { title: "Condition", key: "condition"},
            { title: "Article Type", key: "article_type"},
          ],
          this.fetchCannibalized();
          this.getDispositioncannib();
        }
      },
      fetchToBeCannibalized(){
        const searchArray = this.search_tag && typeof this.search_tag === 'string'
        ? this.search_tag.split(',').map(value => value.trim())
        : []; 
        const params = {
          search_text:searchArray,
          page: this.page,
          per_page: this.pageSize,
        };
        this.$httpSecured
          .get("api/v2/warehouse/cannibalization/to_be_cannibalized", { params : params } )
            .then(response => {
            if (response.data) {
              this.table_data = response.data.cannibalizations
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => { 
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
        });
      },
      fetchWIP(){
        const searchArray = this.search_tag && typeof this.search_tag === 'string'
        ? this.search_tag.split(',').map(value => value.trim())
        : []; 
        const params = {
          search_text: searchArray,
          page: this.page,
          per_page: this.pageSize,
        };
        this.$httpSecured
          .get("/api/v2/warehouse/cannibalization/work_in_progress", { params : params } )
            .then(response => {
            if (response.data) {
              this.table_data = response.data.cannibalizations
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => { 
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
        });
      },
      fetchCannibalized(){
        const searchArray = this.search_tag && typeof this.search_tag === 'string'
        ? this.search_tag.split(',').map(value => value.trim())
        : []; 
        const params = {
          search_text: searchArray,
          page: this.page,
          per_page: this.pageSize,
        };
        this.$httpSecured
          .get("/api/v2/warehouse/cannibalization/cannibalized", { params : params } )
            .then(response => {
            if (response.data) {
              this.table_data = response.data.cannibalizations
              this.totalPages = response.data.meta.total_pages
              this.totalCount = response.data.meta.total_count
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => { 
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
        });
      },
      getDisposition(){
        this.$httpSecured
          .get(`/api/v2/warehouse/cannibalization/to_be_cannibalized/get_dispositions`)
            .then(response => {
            if (response.data) {
              this.change_disposition_list = response.data.dispositions
              // this.loading = false;
            } else {
              // this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => { 
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
        });
      },
      getDispositioncannib(){
        this.$httpSecured
          .get(`/api/v2/warehouse/cannibalization/cannibalized/get_dispositions`)
            .then(response => {
            if (response.data) {
              this.change_disposition = response.data.dispositions
              // this.loading = false;
            } else {
              // this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => { 
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
        });
      },
      changeDisposition(item){
        this.toBeDisposition = true;
        this.dispos_action = item;
      },
      askToBeCannibalized(item){
        this.canniDisposition = true;
        this.dispos_action = item;
      },
      callToBeCannibalized(){
        const ItemId = this.selected.map(item => item.id)
        const dispositionId = this.dispos_action.id
        const requestData = {
          cannibalization: {
              ids: [ItemId] 
          },
          disposition_id: dispositionId
        };
        this.$httpSecured
          .post(`/api/v2/warehouse/cannibalization/cannibalized/change_disposition`, requestData)
          .then(response => {
              if (response.data) {
                  this.canniDisposition = false;
                  this.openPopUp = true;
                  this.message = response.data.message;
              } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
              }
          })
          .catch(error => { 
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      changeDispos(item){
        const ItemId = this.selected.map(item => item.id)
        const dispositionId = this.dispos_action.id
        const requestData = {
            cannibalization: {
                ids: [ItemId] 
            },
            disposition_id: dispositionId
        };
        this.$httpSecured
          .post(`/api/v2/warehouse/cannibalization/to_be_cannibalized/change_disposition`, requestData)
          .then(response => {
              if (response.data) {
                  this.toBeDisposition = false;
                  this.openPopUp = true;
                  this.message = response.data.message;
              } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
              }
          })
          .catch(error => { 
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
      },
      filterListOfButtons(){
        this.filterPopup = true;
        this.selected_article_type = null;
        this.selected_article = null;
        this.selected_cond = null;
        this.tag_id_search = '';
        this.article_id_search = '';
        this.search_tag = '';
        this.selected_uom = null;
        document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 35).toString() + 'px');
      },
      ApplyFilterFunc(){
        this.filterPopup = false;
        this.isFilteringPage = true
        const condition_id = this.selected_cond ? this.selected_cond.id : ''
        const selected_article_id = this.selected_article ? this.selected_article.id : ''
        const selected_article_type_id = this.selected_article_type ? this.selected_article_type.id : ''
        const selected_uom_id = this.selected_uom ? this.selected_uom.id : ''
        if(this.active_tab == "To Be Cannibalized"){
          const requestData = {
            "filter":{
              tag_id: this.tag_id_search,
              article_id: this.article_id_search,
              condition: condition_id,
              article_type : selected_article_id
            },
            page: this.page,
            per_page: this.pageSize,
          };
          this.$httpSecured
          .post(`/api/v2/warehouse/cannibalization/to_be_cannibalized`, requestData )
              .then(response => {
              if (response.data) {
                  this.table_data = response.data.cannibalizations
                  this.totalPages = response.data.meta.total_pages
                  this.totalCount = response.data.meta.total_count
                  this.loading = false;
                  this.selected = [];
              } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
        } else if(this.active_tab == 'Work In Progress'){
          const requestData = {
            "filter":{
              tag_id: this.tag_id_search,
              article_id: this.article_id_search,
              condition: condition_id,
              article_type : selected_article_type_id,
              uom : selected_uom_id
            },
            page: this.page,
            per_page: this.pageSize,
          };
          this.$httpSecured
          .post(`/api/v2/warehouse/cannibalization/work_in_progress`, requestData )
              .then(response => {
              if (response.data) {
                  this.table_data = response.data.cannibalizations
                  this.totalPages = response.data.meta.total_pages
                  this.totalCount = response.data.meta.total_count
                  this.loading = false;
                  this.selected = [];
              } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
        }else if(this.active_tab == 'Cannibalized'){
          const requestData = {
            "filter":{
              tag_id: this.tag_id_search,
              article_id: this.article_id_search,
              condition: condition_id,
              article_type : selected_article_type_id,
              uom : selected_uom_id
            },
            page: this.page,
            per_page: this.pageSize,
          };
          this.$httpSecured
          .post(`/api/v2/warehouse/cannibalization/cannibalized`, requestData )
              .then(response => {
              if (response.data) {
                  this.table_data = response.data.cannibalizations
                  this.totalPages = response.data.meta.total_pages
                  this.totalCount = response.data.meta.total_count
                  this.loading = false;
                  this.selected = [];
              } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
              }
          })
          .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
          });
        }
      },
      handlePageChange(value) {
        this.page = value;
        if(this.isFilteringPage){
          this.filterPageNo = value;
          this.applyFilterFunc()
          return;
        }
        if (this.active_tab == 'To Be Cannibalized') {
          this.fetchToBeCannibalized();
        }else if(this.active_tab == ''){
          this.fetchWIP();
        } else {
          this.fetchCannibalized();
        }
      },
      handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1
        this.filterPageNo = 1;
        if(this.isFilteringPage){
          this.applyFilterFunc();
          return;
        }
        if (this.active_tab == 'To Be Cannibalized') {
          this.fetchToBeCannibalized();
        }else if(this.active_tab == ''){
          this.fetchWIP();
        } else {
          this.fetchCannibalized();
        }
      },
      itemDetailPopup(item){
        this.detailsPopup = true
        this.details_headers = [
            { title: "Article ID", key: "article_id" },
            { title: "Article Description", key: "item_description" },
            { title: "Quantity", key: "quantity"},
            { title: "UOM", key: "uom"},
            { title: "Condition", key: "condition"},
      ];
      const params ={
          id : item.id,
        }
      this.$httpSecured
        .get(`/api/v2/warehouse/cannibalization/cannibalized/get_non_cannibalized`,{params : params})
        .then((response) => {
          this.details_table_data = response.data.cannibalizations;
          this.loading = false;
        })
        .catch((error) => this.$toast.error("Error in retrieving data"));
      }
    },
  }
</script>
<style scoped>
.v-dialog:has(.filter-data){
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
  left: -40px;
  top: 12rem;
}
.custom-control_outlined button {
  min-height: 52px;
  border-width: 1px;
  border-color: rgba(0,0,0,.42);
  border-style: solid;
}
.item-selected{
  margin-top: 23px;
  position: absolute;
  left: 41%;
}
@media (max-height: 1104px) {
  .PaddingItemPerPage{
    padding: 8px !important;
  }
}
@media (min-height: 1126px) {
  .PaddingItemPerPage{
    padding: 24px !important;
  }
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 322px) !important;
}
.custom-width-table .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 170px) !important;
}
</style>
